// ########################
// INFO: Do not delete, archival push notification flow
// ########################

import firebase from '@/vcs/_shared/firebase.js'
import AskForAPNPermission from '@/vcs/_shared/modals/ask-for-apn-permission/cmp.vue'

import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import axios from 'axios'

export default {
  mixins: [CurrentUserResolver],
  methods: {
    startPushNotificationFlow() {
      if (this.currentUser) {
        console.log('startPushNotificationFlow')

        const desktopSafari = 'safari' in window && 'pushNotification' in window.safari
        const ua = window.navigator.userAgent
        const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
        const webkit = !!ua.match(/WebKit/i)
        const iOSSafari = iOS && webkit && !ua.match(/CriOS/i)
        const isFirefoxDesktop = /Firefox/i.test(ua)
        const isChromeDesktop = /Chrome/i.test(ua) && !/Android/i.test(ua)
        const isChromeAndroid = /Chrome/i.test(ua) && /Android/i.test(ua)

        let platform = ''
        if (isChromeAndroid) {
          platform = 'chrome-android'
        } else if (isChromeDesktop) {
          platform = 'chrome-desktop'
        } else if (isFirefoxDesktop) {
          platform = 'firefox-desktop'
        } else if (iOSSafari) {
          platform = 'ios-safari'
        }

        if (desktopSafari) {
          this.flowAPN()
        } else if (isChromeAndroid || isChromeDesktop || isFirefoxDesktop) {
          // android, chrome-desktop, firefox-desktop
          this.flowFCM(platform)
        } else if (iOSSafari) {
          // iOSSafari - No solution for iOS Safari yet. ¯\_(ツ)_/¯
          // Registered first time only when 'ios-safari' user fires push notification flow
          if (JSON.parse(localStorage.getItem('push_notifications_allowed')) == null) {
            this.updateUserActivity('ios-safari', 'push_notification_allowance', false)
          }
          localStorage.setItem('push_notifications_allowed', false)
        }
      }
    },

    async flowFCM(platform) {
      try {
        const messaging = firebase.messaging()
        await messaging.requestPermission()
        const token = await messaging.getToken()

        // Registered when user first time interact with native notification prompt, and ALLOWS it or
        // when user changed his choice from push_notifications_allowed false to true
        if (
          [null, false].indexOf(JSON.parse(localStorage.getItem('push_notifications_allowed'))) !=
          -1
        ) {
          this.updateUserActivity(platform, 'push_notification_allowance', true)
        }
        localStorage.setItem('push_notifications_allowed', true)
        this.sendDeviceToken(token, 'web')
        return token
      } catch (error) {
        // PUSH NOTIFICATIONS NOT ALLOWED
        console.error('---- flowFCM error, no token ----', error)

        // Registered when user first time interact with native notification prompt nad BLOCKS it or
        // when user changed his choice from push_notifications_allowed true to false
        if (
          [null, true].indexOf(JSON.parse(localStorage.getItem('push_notifications_allowed'))) != -1
        ) {
          this.updateUserActivity(platform, 'push_notification_allowance', false)
        }
        localStorage.setItem('push_notifications_allowed', false)
      }
    },

    updateUserActivity(platform, activity, activityValue) {
      const params = {
        userActivity: {
          platform: platform,
          activity: activity,
          activityValue: activityValue,
          metadata: {
            userAgent: window.navigator.userAgent,
          },
        },
      }

      axios({
        method: 'post',
        url: 'user_activities',
        data: params,
      })
        .then(response => {
          console.log('response', response)
        })
        .catch(error => {
          console.error('error updateUserActivity', error)
        })
    },

    sendDeviceToken(token, type) {
      const params = {
        device: { platform: type, token: token },
      }
      axios({
        method: 'post',
        url: 'devices',
        data: params,
      })
        .then(response => {
          console.log('response', response)
        })
        .catch(error => {
          console.error('error sendDeviceToken', error)
        })
    },

    flowAPN() {
      // we rescue this permission, there must me interaction
      const apn_permission = localStorage.getItem('apn_permission')
      if (apn_permission != 'set') {
        this.$store.commit('modal/open', {
          cmp: AskForAPNPermission,
          animation: 'slide-left-modal',
          data: {},
        })
      } else {
        console.log(
          '%c SAFARI NOTIFICATION PERMISSION ALREADY SET',
          'color: #e01a66; font-weight: bold;',
        )
      }
    },
  },
}
